const seePublicResearchesPermissions = ['public_researches:admins', 'public_researches:viewers'];

const createPublicResearchesPermissions = [];

const anyPublicResearchesPermissions = [...seePublicResearchesPermissions, ...createPublicResearchesPermissions];

export { anyPublicResearchesPermissions, createPublicResearchesPermissions, seePublicResearchesPermissions };
